import $ from 'jquery';
import API from '../endpoints.json';

const FETCH_FLIGHTS_SUCCESS = 'fetch:flights:success';
const fetchFlightsSuccess = data => ({
    type: FETCH_FLIGHTS_SUCCESS,
    payload: data,
});

const FETCH_FLIGHTS_FAIL = 'fetch:flights:fail';
const fetchFlightsFail = error => ({
    type: FETCH_FLIGHTS_FAIL,
    payload: { error },
});

const fetchFlights = (range, start, end) =>
    dispatch => $.get(API.FLIGHTS, {
        range, start, end,
    }).done((data, textStatus, jqXHR) => {
        dispatch(fetchFlightsSuccess(data));
    }).fail((jqXHR, status, error) => {
        dispatch(fetchFlightsFail(jqXHR.responseText || error));
    });

const fetchFlightsSearch = (range, start, end) =>
    dispatch => $.get(API.FlightSearch, {
        range, start, end,
    }).done((data, textStatus, jqXHR) => {
        dispatch(fetchFlightsSuccess(data));
    }).fail((jqXHR, status, error) => {
        dispatch(fetchFlightsFail(jqXHR.responseText || error));
});
const SET_SELECTED_FLIGHT = 'set:selected:flight';
const setSelectedFlight = flight => ({
    type: SET_SELECTED_FLIGHT,
    payload: flight,
});

const fetchFlightDetails = ({ id, start, end, flt, dep, arr, reg }) =>
    dispatch => $.get(API.FLIGHTS + `/${id}`, {
        start, end, flt, dep, arr, reg,
    });

const UPDATE_FLIGHT_DETAILS = 'update:flight:details';
const _updateFlightDetails = (index, flight) => ({
    type: UPDATE_FLIGHT_DETAILS,
    payload: { index, flight }
})

const updateFlightDetails = (flight, index, server) =>
    dispatch => {
        if (server) {
            const { id, flt, dep, arr, std, fic, adc, remark1, remark2 } = flight;
            $.ajax({
                url: `${API.FLIGHTS}/${id}`,
                type: 'PUT',
                data: { flt, dep, arr, std, fic, adc, remark1, remark2 },
            });
        }
        dispatch(_updateFlightDetails(index, flight));
    };

const fetchFlightDocuments = (id, data) =>
    dispatch => $.get(API.FLIGHTS + `/${id}/documents`, data);

const fetchFlightBriefingSheet = (id, data) =>
    dispatch => $.get(API.FLIGHTS + `/${id}/briefingsheet`, data);

const saveFlightBriefingSheet = (id, data) =>
    dispatch => $.post(API.FLIGHTS + `/${id}/briefingsheet`, data);

const saveFlightDocument = (id, file) => {
    let formData = new FormData();
    formData.append('file', file);
    return dispatch => $.ajax({
        url: `${API.FLIGHTS}/${id}/documents`,
        type: 'POST',
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
    });
}

const updateFlightDocument = (id, change) =>
    dispatch => $.ajax({
        url: `${API.DOCUMENTS}/${id}`,
        type: 'PUT',
        data: change,
    });
const deleteFlightDocument = id =>
    dispatch => $.ajax({
        url: `${API.DOCUMENTS}/${id}`,
        type: 'DELETE',
    })

const download = id =>
    dispatch => window.open(`${API.DOCUMENTS}/${id}`, '_target');

const generateEff = (id, options) =>
    dispatch => $.post(`${API.FLIGHTS}/${id}/eff`, options);

const emailEff = (id, options) =>
    dispatch => $.post(`${API.FLIGHTS}/${id}/eff/email`, options);

const SET_FLIGHTS_FILTERS = 'set:flights:filters';
const setFlightsFilters = filters => ({
    type: SET_FLIGHTS_FILTERS,
    payload: filters,
});

const RESET_FLIGHTS_FILTERS = 'reset:flights:filters';
const resetFlightsFilters = filters => dispatch => { };

const SET_FLIGHTS_OPTION = 'set:flights:option';
const setFlightsOption = option => {
    console.log(option,'checking option inside api call action')
    return ({
    type: SET_FLIGHTS_OPTION,
    payload: option,
})};

export {
    SET_FLIGHTS_OPTION,
    setFlightsOption,
    FETCH_FLIGHTS_SUCCESS,
    FETCH_FLIGHTS_FAIL,
    fetchFlights,
    SET_SELECTED_FLIGHT,
    setSelectedFlight,
    fetchFlightDetails,
    UPDATE_FLIGHT_DETAILS,
    updateFlightDetails,
    fetchFlightDocuments,
    fetchFlightBriefingSheet,
    saveFlightBriefingSheet,
    saveFlightDocument,
    updateFlightDocument,
    deleteFlightDocument,
    download,
    generateEff,
    emailEff,
    SET_FLIGHTS_FILTERS,
    RESET_FLIGHTS_FILTERS,
    setFlightsFilters,
    resetFlightsFilters,
    fetchFlightsSearch
}